import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const IntakeHeader = ({ selectedPathway, currentStep, steps, onBack }) => {
  return (
    <div className="mb-8">
      <Button
        variant="ghost"
        iconName="ArrowLeft"
        iconPosition="left"
        onClick={onBack}
        className="mb-4"
      >
        {currentStep === 0 ? 'Change Pathway' : 'Previous Step'}
      </Button>
      
      <div className="flex items-center justify-between mb-2">
        <h1 className="text-2xl font-semibold text-foreground">
          {selectedPathway === 'quick' ? 'Quick Start' : 'Comprehensive Assessment'}
        </h1>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Icon name="Clock" size={16} />
          <span>
            {selectedPathway === 'quick' ? '2-3 min' : '8-10 min'} remaining
          </span>
        </div>
      </div>
    </div>
  );
};

export default IntakeHeader;